/*============================================================================
  Gestione PopUp newsletter
  
==============================================================================*/
(function () {
	
	
	function backInStockPopUp() {
		let $self = this;
		
		let translatedString = [];
		translatedString["The email address you entered is invalid"] = window.backInStockTranslate.popup.returnedMessage.emailNotValid;
		translatedString["You have already registered for a notification for that item."] = window.backInStockTranslate.popup.returnedMessage.alreadyRegistered;
		
		
		let $popup = null;
		let $errorPrivacy = null;
		
		let $form = null;
		
		/**
		 * Parametri per Back In Stock App
		 */
		let $variantId, $productId;
		
		let selectorPopUp = "#cosBackInStock_container";
		let selectorErrorPrivacy = "#cosPopupBackInStock_privacy_err_back-in-stock";
		
		/**
		 *
		 * @param $_selector
		 * @returns {undefined|JQuery<HTMLElement>|jQuery|HTMLElement}
		 */
		this.getObjectFromSelector = function ($_selector) {
			if ($($_selector)[0]) {
				return $($($_selector)[0]);
			}
			return undefined;
		};
		
		/**
		 *
		 * @returns {HTMLElement|null}
		 */
		this.getPopup = function () {
			if ($popup == null) {
				return this.getObjectFromSelector(selectorPopUp);
			}
			return $popup;
		};
		
		this.getErrorPrivacy = function () {
			if ($errorPrivacy == null) {
				return this.getObjectFromSelector(selectorErrorPrivacy);
			}
			return $errorPrivacy;
		};
		
		this.getFormFieldValue = function ($_key) {
			return $("#" + $form.data('form-id') + "_" + $_key).val();
		};
		
		
		this.getTranslatedString = function ($key) {
			if (translatedString.hasOwnProperty($key)) {
				return translatedString[$key];
			}
			return $key;
		};
		
		this.handleEvent = function () {
			if (typeof this.getPopup() !== 'undefined') {
				
				$form = this.getPopup().find('form');
				
				
				/**
				 * Validate Form
				 */
				$form.validate({
					rules: {
						"email": {
							required: true,
							mail: true
						},
						"acceptrivacy": {
							required: true
						}
					},
					invalidHandler: function (event, validator) {
						// alert('ERRORE invalid');
					},
					errorPlacement: function (error, element) {
						
						// alert('ERRORE error');
						
						if (element.attr('type') === 'checkbox') {
							if (typeof $self.getErrorPrivacy() !== "undefined") {
								error.appendTo($self.getErrorPrivacy());
								$self.getErrorPrivacy().removeClass('hide').css({"width": "100%"});
							}
						} else {
							error.insertAfter(element);
						}
					},
					submitHandler: function (form) {
						BIS.create($self.getFormFieldValue('Email'), $variantId, $productId).then(
							function (resp) {
								if (resp.status === 'OK') {
									$self.requestShowMessageOk(backInStockTranslate.popup.message["back-in-stock-ok"]);
								} else {
									let ErrorMessage = "";
									$(resp.errors).each(function (index, item) {
										if (typeof item === 'object') {
											for (let i in item) {
												if (typeof item[i] === 'object') {
													for (let j in item[i]) {
														ErrorMessage = ErrorMessage + $self.getTranslatedString(item[i][j]) + "<br>";
													}
												} else {
													ErrorMessage = ErrorMessage + $self.getTranslatedString(item[i]) + "<br>";
												}
											}
										} else {
											ErrorMessage = ErrorMessage + $self.getTranslatedString(item) + "<br>";
										}
									});
									if (ErrorMessage === "") {
										ErrorMessage = backInStockTranslate.popup.message["back-in-stock-error"];
									}
									$self.requestShowMessageError(ErrorMessage);
								}
							}
						);
					}
				});
			}
		};
		
		/**
		 * Imposta i valori per il form da inviare all'app
		 * @param productId
		 * @param variantId
		 * @returns {boolean}
		 */
		this.setFormValue = function (productId, variantId) {
			$variantId = variantId;
			$productId = productId;
			
			if (this.getPopup().find('#back_in_stock_productId').length !== 1 || this.getPopup().find('#back_in_stock_variantId').length !== 1) {
				return false;
			}
			this.getPopup().find('#back_in_stock_productId').val($productId);
			this.getPopup().find('#back_in_stock_variantId').val($variantId);
			return true;
		};
		
		/**
		 * Visializza la popup
		 * @param productId
		 * @param variantId
		 */
		this.showPopUp = function (productId, variantId) {
			if (typeof this.getPopup() !== 'undefined') {
				if (this.setFormValue(productId, variantId) === true) {
					$.magnificPopup.open({
						mainClass: "bgDark white",
						items: {
							src: selectorPopUp
						},
						type: 'inline',
						callbacks: {
							close: function () {
								// Will fire when popup is closed
								$self.setFormValue('', '');
							}
						}
					});
				}
			}
		};
		
		this.showPopUpMessage = function ($type, $message, $options) {
			let $_mainClass = "bgDark white";
			if (typeof $options !== 'undefined') {
				if ($options.mainClass) {
					$_mainClass = $options.mainClass;
				}
			}
			
			
			$('#cosPopUpMessage' + $type).find('p').html($message);
			
			$.magnificPopup.open({
				mainClass: $_mainClass,
				items: {
					src: '#cosPopUpMessage' + $type
				},
				type: 'inline',
				callbacks: {
					close: function () {
						$('#cosPopUpMessage' + $type).find('p').html('');
					}
				}
			});
		};
		
		this.requestShowMessageOk = function ($message) {
			this.showPopUpMessage('Ok', $message);
		};
		this.requestShowMessageError = function ($message) {
			this.showPopUpMessage('Error', $message);
		};
		
		this.makeRequest = function () {
			// BIS.create('pm.cooder@gmail.com', 123456, 987654).then(function(resp) { resp.status == 'OK' ? alert(resp.msg) : alert(resp.status) });
			
		};
		
		/**
		 * Inizializzazione oggetto
		 * @param options
		 */
		this.init = function () {
			this.getPopup();
			this.getErrorPrivacy();
			this.handleEvent();
			
		};
	}
	
	// Export variable
	let cc = new backInStockPopUp();
	window.backInStockPopUp = {
		init: cc.init.bind(cc),
		showPopUp: cc.showPopUp.bind(cc)
	};
	
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Collection Carousel
  
==============================================================================*/
(function () {
	function complete_your_look_carousel(dom) {
		let $id = dom.data("section-id");
		let $carousel = null;
		
		let $items = null;
		
		this.settings = {
			loop: false,
			margin: 0,
			nav: false,
			dots: false,
			autoplay: false,
			autoplayHoverPause: true,
			// center:true,
			mouseDrag: true,
			touchDrag: true,
			autoWidth: false,
			// stagePadding:50,
			responsive: {
				0: {
					items: 1,
					// center: true
					// stagePadding:50
				},
				590: {
					items: 5
				}
			}
		};
		
		this.getId = function () {
			return $id;
		};
		
		this.getCarousel = function () {
			if ($carousel == null) {
				$carousel = $('.owl-carousel', ".cosCompleteYourLook");
			}
			return $carousel;
		};
		
		this.destroy = function () {
			if ($carousel != null) {
				this.getCarousel().owlCarousel('destroy');
				$carousel = null;
				$items = null;
			}
		};
		
		this.create = function (options) {
			this.settings = $.extend(this.settings, options);
			this.destroy();
			
			// this.settings.autoplay = resolution_IsMobile();
			
			console.log('CERATE CAROUSEL ', this.settings);
			
			this.getCarousel().owlCarousel(this.settings);
			$items = this.getCarousel().find('.item');
			
			this.addHandler();
		};
		
		this.addHandler = function () {
			//manege hover event
			$($items).hover(
				function () {
					if (!resolution_IsMobile()) {
						$(this).find('.show-on-hover-desktop').css('opacity', 1);
					}
				}, function () {
					if (!resolution_IsMobile()) {
						$(this).find('.show-on-hover-desktop').css('opacity', 0);
					}
				}
			);
		};
	}
	
	function completeYourLookController() {
		let $carouselItems = [];
		this.settings = {
			selector: '.cosCompleteYourLook'
		};
		
		this.getItems = function () {
			return $carouselItems;
		};
		
		
		this.init = function (options) {
			// Override defaults with arguments
			
			this.settings = $.extend(this.settings, options);
			
			$(this.settings.selector).each(function (index, itm) {
				const c = new complete_your_look_carousel($(itm));
				
				let vi_m = 1;
				let vi_d = 5;
				
				if ($(itm).data("visible-items-mobile") !== undefined) {
					vi_m = $(itm).data("visible-items-mobile");
				}
				if ($(itm).data("visible-items-desktop") !== undefined) {
					vi_d = $(itm).data("visible-items-desktop");
				}
				
				let options = {
					responsive: {
						0: {
							items: vi_m,
							// center: true,
							autoWidth: false,
							startPosition: 2
						},
						590: {
							items: vi_d,
							center: false/*,
							stagePadding:150*/
						}
					}
				};
				c.create(options);
				$carouselItems[c.getId()] = c;
			});
			
		};
	}
	// Export variable
	let completeYourLookCarouselController = new completeYourLookController();
	window.completeYourLookCarouselController = {
		init: completeYourLookCarouselController.init.bind(completeYourLookCarouselController),
		getCarousel: completeYourLookCarouselController.getItems.bind(completeYourLookCarouselController)
	};
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Collection Carousel
  
==============================================================================*/
(function () {
	function productRecommendationsCarousel(dom) {
		let $id = dom.data("section-id");
		let $dom = dom;
		let $carousel = null;
		
		let $items = null;
		
		this.settings = {
			loop: false,
			margin: 0,
			nav: false,
			dots: false,
			autoplay: false,
			autoplayTimeout:2000,
			autoplayHoverPause: true,
			// center:true,
			mouseDrag: true,
			touchDrag: true,
			// autoWidth: false,
			// stagePadding:50,
			responsive: {
				0: {
					items: 1,
					// center: true
					// stagePadding:50
				},
				590: {
					items: 5
				}
			}
		};
		
		this.getId = function () {
			return $id;
		};
		
		this.getIndexTab = function () {
			return $dom.data('index-tab');
		};
		
		this.getCarousel = function () {
			if ($carousel == null) {
				$carousel = $dom.find('.owl-carousel');
			}
			return $carousel;
		};
		
		this.destroy = function () {
			if ($carousel != null) {
				this.getCarousel().owlCarousel('destroy');
				$carousel = null;
				$items = null;
			}
		};
		
		this.toggleClass = function () {
			$dom.toggleClass('active');
		};
		
		this.create = function (options) {
			this.settings = $.extend(this.settings, options);
			this.destroy();
			
			//console.log('CREATE CAROUSEL ',this.settings);
			
			// this.settings.autoplay = resolution_IsMobile();
			this.getCarousel().owlCarousel(this.settings);
			$items = this.getCarousel().find('.item');
			
			this.addHandler();
		};
		
		this.addHandler = function () {
			//manege hover event
			$($items).hover(
				function () {
					if (!resolution_IsMobile()) {
						$(this).find('.show-on-hover-desktop').css('opacity', 1);
					}
				}, function () {
					if (!resolution_IsMobile()) {
						$(this).find('.show-on-hover-desktop').css('opacity', 0);
					}
				}
			);
		};
	}
	
	function _productRecommendationsCarouselController() {
		let $tabLink=[];
		let $tabItems=[];
		let $tabItemsSelected=null;
		
		let $carouselItems = [];
		let $self= this;
		let $dom = null;
		
		$self.settings =  {
			visible_item: {
				mobile: 2.5,
				desktop:5
			}
		};
		
		this.toggleTab = function ($_indexToShow) {
			if ($tabItemsSelected!= null) {
				if ($tabItems[$_indexToShow] == $tabItemsSelected) {
					return true;
				}
				$tabItemsSelected.toggleClass('active');
				$carouselItems[$tabItemsSelected.data('tab-id')].toggleClass('active');
			}
			$tabItems[$_indexToShow].toggleClass('active');
			$carouselItems[$_indexToShow].toggleClass('active');
			$tabItemsSelected=$tabItems[$_indexToShow];
			$dom.find('.tabs-container-wrapper').css('marginLeft', '-' + ($carouselItems[$_indexToShow].getIndexTab()*100)+"vw");
		};
		
		this.getCarousel = function () {
			return $carouselItems;
		};
		
		this.initTabs = function () {
			$dom.find('.tab-link').each(function (index,itm) {
				$tabLink[$(itm).data('tab-id')]=$(itm);
				
				$tabItems[$(itm).data('tab-id')]=$(itm);
				$tabItems[$(itm).data('tab-id')].on('click', function (evt) {
					evt.preventDefault();
					$self.toggleTab($(this).data('tab-id'));
				})
			});
		};
		
		/**
		 * Imposta il contenuto delle tab
		 */
		this.initTabsContent = function () {
			$dom.find('.cosProductRecommendationsCarousel').each(function (index, itm) {
				const c = new productRecommendationsCarousel($(itm));
				
				if ($(itm).data("visible-items-mobile") !== undefined) {
					if($(itm).data("visible-items-mobile") !== "") {
						$self.settings.visible_item.mobile = $(itm).data("visible-items-mobile");
					}
				}
				if ($(itm).data("visible-items-desktop") !== undefined) {
					if($(itm).data("visible-items-desktop") !== "") {
						$self.settings.visible_item.desktop = $(itm).data("visible-items-desktop");
					}
				}
				
				let vi_m = $self.settings.visible_item.mobile;
				let vi_d = $self.settings.visible_item.desktop;
				
				let options = {
					loop:true,
					responsive: {
						0: {
							items: vi_m,
							center: true, //Set = false -> bug swipe.
							autoWidth: false,
							stagePadding: 0,
							autoplay: false,
							startPosition:0
							
						},
						590: {
							items: vi_d,
							center: false
							
							//Auto height
							
						}
					}
				};
				//console.log('AVVIA CREATE CAROUSEL', options);
				c.create(options);
				$carouselItems[c.getId()] = c;
			});
		};
		
		/**
		 * Seleziono il primo elemento
		 */
		this.selectFirstElement = function () {
			for (var key in $tabLink) {
			 	if ($tabLink[key].parent().css('display') !== 'none') {
					$tabItems[key].click();
					break;
				}
			}
			// for (var key in $tabItems) {
			// console.log('key=',key);
			// console.log('css display=',$tabItems[key].css('display'));
			// 	if ($tabItems[key].css('display') !== 'none') {
			// 		$tabItems[key].click();
			// 		break;
			// 	}
			// }
		};

		
		this.init = function ($_mainSelector,options) {
			// Override defaults with arguments
			
			this.settings = $.extend($self.settings, options);
			$dom = $($_mainSelector);
			this.initTabs();
			this.initTabsContent();
			this.selectFirstElement();
		};
	}
	// Export variable
	let productRecommendationsCarouselController = new _productRecommendationsCarouselController();
	window.productRecommendationsCarouselController = {
		init: productRecommendationsCarouselController.init.bind(productRecommendationsCarouselController),
		getCarousel: productRecommendationsCarouselController.getCarousel.bind(productRecommendationsCarouselController)
	};
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Gestione drodown selezione varianti scheda prodotto
==============================================================================*/
(function () {
	function cosProductSelectVariant  (dom) {
		// Private plugin variables
		let $body = $("body");
		let $self = this;
		var $dropDownContainer = dom,
			$dropDownTitle,
			$dropDownItemOpenClose_title,
			$dropDownContent,
			$dropDownItems,
			$dropDownItemsDefault,
			$itemActive,
			$updateValueObject,
			$updateValueObject_1,
			$updateValueObject_2,
			$dropDownItemOpenClose,
			$textOpenBtn,
			$textCloseBtn,
			$heightdropDownContainer = 0;
			$heightdropDownContent = 0;
			$_PlaceHolder="";
		
		// Private general variables
		var  isOpened, isMobile, $updateMultipleObject = false;
		
		
		this.settings = {
			dropDownTitle: '.drop-down_title',
			dropDownContent: '.drop-down_content',
			updateValueObject: '.product-single__variants',
			textOpenBtn: "Seleziona Taglia",
			textCloseBtn: "Seleziona Taglia"
		};
		
		
		this.setDropDownItemDefault = function () {
			$dropDownItemsDefault = $dropDownContent.find('.dropdownselectvalue.active');
		};
		
		/*============================================================================
				Initialise the plugin and define global options
			==============================================================================*/
		this.init = function (options) {
			// Override defaults with arguments
			$.extend(this.settings, options);
			
			$heightdropDownContainer = $dropDownContainer.height();
			
			// Select DOM elements
			$dropDownTitle = $dropDownContainer.find(this.settings.dropDownTitle);
			
			$dropDownItemOpenClose = $dropDownTitle.find('button');
			$dropDownItemOpenClose_title = $dropDownItemOpenClose.find('span');
			$dropDownContent = $dropDownContainer.find(this.settings.dropDownContent);
			$dropDownItems = $dropDownContent.find('.dropdownselectvalue');
			
			this.setDropDownItemDefault();
			
			
			$updateValueObject = $($dropDownContainer.data('update-value-object'));
			$updateValueObject_1 = $($dropDownContainer.data('update-value-object-one'));
			$updateValueObject_2 = $($dropDownContainer.data('update-value-object-two'));
			
			$dropDownContent.removeClass('hide');
			$heightdropDownContent = $dropDownContent.outerHeight(true);
			$dropDownContent.addClass('hide');
			
			$_PlaceHolder = $dropDownItemOpenClose_title.html();
			
			$textOpenBtn = $dropDownItemOpenClose.data('text-open');
			$textCloseBtn = $dropDownItemOpenClose.data('text-close');
			
			if (typeof $dropDownContainer.data('update-value-multiple-object') !== 'undefined') {
		 		$updateMultipleObject = $dropDownContainer.data('update-value-multiple-object');
			} else {
				$updateMultipleObject = false
			}
			
				/**
			 * dropDown Aperto
			 * @type {boolean}
			 */
			isOpened = false;
			
			/**
			 * Versione Mobile
			 * @type {boolean}
			 */
			isMobile = false;
			
			
			this.setItemActive($dropDownItems.filter('.active'));
			
			this.setOpenClosedropDown();
			this.setdropDownItemsClick();
			this.setDefaultValue();
		};
		
		this.setItemActive = function ($itm) {
			if ($itm.length === 0) {
				$itemActive = undefined;
			}  else {
				$itemActive = $itm;
			}
		};
		
		this.setOpenClosedropDown = function () {
			$dropDownItemOpenClose.on('click', function (evt) {
				if (isOpened) {
					if ($dropDownItemsDefault.length>0) {
						
						$dropDownItemsDefault.click();
					} else {
						$self.closedropDown();
					}
					
					
					//$self.closedropDown();
				} else {
					$self.opendropDown(isMobile);
				}
			});
			
		};
		
		this.opendropDown = function (mobile) {
			isMobile = mobile;
			if (!isOpened) {
				//Change Text to placeholder and change class
				$dropDownItemOpenClose_title.html($_PlaceHolder);
				$dropDownItemOpenClose_title.removeClass('selectedSize');
				
				//
				$body.trigger("select-variant-opendropDown-before",[this]);
				isOpened = true;
				$dropDownContent.removeClass('hide');
				this.animatedropDownOpen();
				$body.trigger("select-variant-opendropDown-after",[this]);
			}
		};
		
		/** dropDown normal **/
		this.closedropDown = function () {
			if (isOpened) {
				$body.trigger("select-variant-closedropDown-before",[this]);
				isOpened = false;
				this.animatedropDownClose();
				$body.trigger("select-variant-closedropDown-after",[this]);
			}
		};
		
		this.animatedropDownOpen = function () {
			if (isMobile) {
				// TweenMax.to($dropDownContainer, 0.5,
				//     {
				//         left: "0px",
				//         opacity: "1",
				//         ease: Power2.easeInOut,
				//         onCompleteScope: $dropDownContainer,
				//         onComplete: function () {
				//             showChild(blockID);
				//             animatedropDownMobileLogo(true);
				//         }
				//     });
			} else {
				var tl = new TimelineLite();
				$dropDownTitle.addClass('opened');
				
				$dropDownItemOpenClose_title.html($textCloseBtn);

				TweenMax.fromTo($dropDownContent, 0.5,
					{
						height: "0px",
						opacity: 0,
						marginTop:"-5px",
					}, {
						height: $heightdropDownContent + "px",
						opacity: 1,
						marginTop:"0px",
						ease: Power2.easeInOut
					});
				
				
			}
			
		};
		
		this.animatedropDownClose = function () {
			if (isMobile) {
				// TweenMax.to($dropDownContainer, 0.5,
				//     {
				//         left: "-" + $dropDownContainer.width() + "px",
				//         opacity: "0",
				//         ease: Power2.easeInOut,onComplete: function() {
				//             //Nasconde tutti i contenitori dei dropDown
				//             $('[class*="mnu_"]').removeClass('active').addClass('hide');
				//             hideChild(dropDownBlockIDOpened);
				//             animatedropDownMobileLogo(false);
				//         }
				//     });
			} else {
				
				
				$dropDownTitle.removeClass('opened');
				$dropDownItemOpenClose_title.html($textOpenBtn);
				
				
				TweenMax.fromTo($dropDownContent, 0.5,
					{
						height: $heightdropDownContent + "px",
						opacity: 1
					}, {
						height: "0px",
						opacity: 0,
						marginTop:"-5px",
						ease: Power2.easeInOut
					});
				
			}
		};
		
		this.setdropDownItemsClick = function () {
			$dropDownItems.on('click', function () {
				$(this).siblings().removeClass('active');
				$(this).addClass('active');
				$self.setDropDownItemDefault();
				if ($updateMultipleObject) {
					$updateValueObject_1.val($(this).data('value-one'));
					$updateValueObject_1.change();
					$updateValueObject_2.val($(this).data('value-two'));
					$updateValueObject_2.change();
					
					$dropDownItemOpenClose_title.html($(this).html());
					$dropDownItemOpenClose_title.addClass('selectedSize');
					
					if ($(this).data("call-back-in-stock") === true) {
						/**
						 * Initialize BackInStock popup
						 */
						
						if (typeof newsletterPopUp != 'undefined') {
							backInStockPopUp.showPopUp($(this).data("product-id"), $(this).data("variant-id"));
						}
					} else {
					
					}
					
					$self.closedropDown();
					
				} else {
					$updateValueObject.val($(this).data('value'));
					$updateValueObject.change();
				}
			});
		};
		
		/**
		 * Seleziona l'elemento attivo
		 */
		this.setDefaultValue = function () {
			$dropDownItemsDefault.click();
		};
		
		this.getState = function () {
			return isOpened;
		};
	}
	
	function _cosProductSelectVariantCollection () {
		
		let selectVariant = [];
		
		this.add = function (dom) {
			let c = new cosProductSelectVariant(dom);
			c.init();
			//se//lectVariant.push(c)
		};
	}
	
	// // Export variable
	let cc = new _cosProductSelectVariantCollection();
	window.cosProductSelectVariantCollection = {
		add: cc.add.bind(_cosProductSelectVariantCollection),
	};
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Gestione drodown selezione varianti schda prodotto
==============================================================================*/
(function () {
	function _cosProductTemplate() {
		let $body = $("body");
		let $self = this;
		
		let $productAddedToCart_productSingleObject = null;
		let $productAddedToCart_buttonClose = null;
		let $productAddedToCart = null;
		let $productAddedToCart_IMAGE = null;
		let $productAddedToCart_BRAND = null;
		let $productAddedToCart_TITLE = null;
		let $productAddedToCart_PRICE_COMPARE_AT = null;
		let $productAddedToCart_PRICE_SINGLE_PRICE = null;
		
		let $productBarSticky = false;
		let $productBarOriginalTop = 0;
		
		this.settings = {
			"selector": {
				"popUpProductsContactsModule_lnk": ".openproductscontactsmodule",
				"popUpSizeTable_lnk": ".opensizeguide",
				"popUpSizeTable": "#cosPopUpSizeTable",
				"showItemAdded": "#productAddedToCart",
				"productAddedToCart": "#productAddedToCart"
			}
		};
		
		this.initProductsModuleContacts = function () {
			$(this.settings.selector.popUpProductsContactsModule_lnk).magnificPopup({
				mainClass: "bgDark",
				type: 'inline',
				midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
				callbacks: {
					open: function() {
						var magnificPopup = $.magnificPopup.instance;
						$('body,html').css('overflow', 'hidden');
					},
					close: function () {
						// Will fire when popup is closed
						$('body,html').css('overflow', '');
					}
				}
			});
			
			
		};
		
		this.initSizeTable = function () {
			let sizeTable = $(this.settings.selector.popUpSizeTable);
			let $popUpSizeTable_lnk = $(this.settings.selector.popUpSizeTable_lnk);
			let table = sizeTable.find(".cos_table");
			let padding_left = parseInt($('#cosPopUpSizeTable').css('paddingLeft'));
			let padding_right = parseInt($('#cosPopUpSizeTable').css('paddingRight'));
			let width_column = 60; //Check with styles setted
			let total_columns = parseInt(table.data('total-cols'));
			let max_wdth = (total_columns * width_column) + padding_left + padding_right;
			
			sizeTable.css({'maxWidth': max_wdth + 'px'});
			
			let popupClass="bgDark";
			if (resolution_IsMobile()) {
				//popupClass="bgBlack opacity-1";
			}
			
			$('.mfp-close-popup-lnk').on('click', function(e) {
				var mp = $.magnificPopup.instance;
				mp.close();
			});
			
			$popUpSizeTable_lnk.magnificPopup({
				mainClass:popupClass,
				type: 'inline',
				midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
				callbacks: {
					open: function() {
						//var magnificPopup = $.magnificPopup.instance;
						$('body,html').css('overflow', 'hidden');
					},
					close: function () {
						// Will fire when popup is closed
						$('body,html').css('overflow', '');
						
					}
				}
			});
		};
		
		this.initItemAdded = function () {
			$productAddedToCart_productSingleObject = JSON.parse(document.getElementById('ProductJson-product-template').innerHTML);
			$productAddedToCart = $(this.settings.selector.productAddedToCart);
			$productAddedToCart_buttonClose = $productAddedToCart.find('button');
			$productAddedToCart_IMAGE = $productAddedToCart.find('.img').find('img');
			$productAddedToCart_BRAND = $productAddedToCart.find('.brand');
			$productAddedToCart_TITLE = $productAddedToCart.find('.title');
			$productAddedToCart_PRICE_COMPARE_AT = $productAddedToCart.find('.compare-at');
			$productAddedToCart_PRICE_SINGLE_PRICE = $productAddedToCart.find('.single__price');
			
			$productAddedToCart_buttonClose.on('click', function () {
				$self.hideItemAdded();
			});
		};
		this.showItemAddedRestDefaultValue = function () {
			$productAddedToCart_IMAGE.attr('src', '');
			$productAddedToCart_BRAND.html('');
			$productAddedToCart_TITLE.html('');
			$productAddedToCart_PRICE_COMPARE_AT.html('');
			$productAddedToCart_PRICE_COMPARE_AT.css({"display": "none"});
			$productAddedToCart_PRICE_SINGLE_PRICE.html('');
		};
		this.showItemAdded = function (datas, htmlForm) {
			$self.showItemAddedRestDefaultValue();
			
			for (let tag in $productAddedToCart_productSingleObject.tags) {
				let tagValue = $productAddedToCart_productSingleObject.tags[tag].split('filter-Brand_');
				if (tagValue.length === 2) {
					$productAddedToCart_BRAND.html(tagValue[1]);
					break;
				}
			}
			
			$productAddedToCart_IMAGE.attr('src', datas.featured_image.url);
			$productAddedToCart_TITLE.html(datas.product_title);
			$productAddedToCart_PRICE_SINGLE_PRICE.html(theme.Currency.formatMoney(datas.final_price, theme.strings.moneyFormat));
			
			$productAddedToCart.css({"display": 'block', "opacity": "0"});
			TweenMax.to($productAddedToCart, 0.8, {opacity: 1});
			setTimeout(function () { $self.hideItemAdded(); }, 2500);
		};
		
		this.hideItemAdded = function () {
			$productAddedToCart.css({"opacity": "1"});
			TweenMax.to($productAddedToCart, 0.8, {
				opacity: 0,
				onComplete: function () {$productAddedToCart.css({'display': "none"}), $self.showItemAddedRestDefaultValue();}
			});
		};
		
		
		this.setProductBarFixed = function () {
			let top_of_screen = $(window).scrollTop();
			let padding_top = parseInt($('.main-content').css('paddingTop')) | 0;
			let startToShow = 0;
			if (resolution_IsMobile()) {
				startToShow = $('.product-single__add-to-cart').offset().top + $('.product-single__add-to-cart').height() - padding_top;
			} else {
				startToShow = $('.grid.product-single').offset().top + $('.grid.product-single').height() - padding_top;
			}
			if (startToShow <= top_of_screen) {
				if (!$productBarSticky) {
					if (resolution_IsMobile()) {
						$('#product-bar').addClass('fixed').css({'bottom': 0});
					} else {
						$('#product-bar').addClass('fixed').css({'top': ($('.header-container').outerHeight())});
					}
					$productBarSticky = true;
				}
			} else {
				$('#product-bar').removeClass('fixed').css({'top': '', 'bottom': ''});
				$productBarSticky = false;
			}
		};
		
		this.initProductBar = function () {
			$productBarOriginalTop = $("#product-bar").offset().top;
			
			//$(window).on('resize', theme.debounce($self.setProductBarFixed, 150).bind(this))
			//.on('scroll', theme.debounce($self.setProductBarFixed, 60).bind(this));
			
			$(window).on('resize', theme.debounce($self.setProductBarFixed, 150).bind(this))
				.on('scroll', $self.setProductBarFixed);
			
			
			$('.clickScrollToTopProduct').on('click', function (e) {
					e.preventDefault();
					$("html, body").animate({scrollTop: $('.grid__item.product-single__meta--wrapper.dx').offset().top}, "slow");
				}
			);
			
			$self.setProductBarFixed();
			
		};
		
		this.initPopupContactsForm = function () {
			$('#cosPopupProductsModuleContatcsForm').validate({
				rules: {
					"email": {
						required: true,
						mail: true
					},
					"message": {
						required: true
					},
					"acceptrivacy": {
						required: true
					}
				},
				errorPlacement: function (error, element) {
					if (element.attr('type') == 'checkbox') {
						error.appendTo($('#cosPopupProductsModuleContatcsForm_privacy_err'));
						$('#cosPopupProductsModuleContatcsForm_privacy_err').removeClass('hide').css({"width": "100%"});
					} else {
						error.insertAfter(element);
					}
				},
				submitHandler: function (form) {
					//form.submit();
					var $cf = $(form);
					/*	console.log("type:,", $cf.attr('method'));
						console.log("url:," ,$cf.attr('action'));
						console.log("data:,", $cf.serialize());
					*/
					
					$.ajax({
						type: $cf.attr('method'),
						//url: 'https://blush-italy.myshopify.com/contact#cosCmsContacts',
						url: 'https://blush-shop.it/contact#cosCmsContacts',
						data: $cf.serialize(),
						success: function (data) {
							//			alert('INVIO CORRETO');
						},
						error: function (data) {
							//	alert('ERRORE REINVIO MODULO');
							//		$('input[name="challenge"]', $cf).val('true');
							//$cf.submit();
						}
					});
					
					
				},
				invalidHandler: function (event, validator) {
					// console.log('non valido');
				},
				success: function (event, validator) {
					//	 console.log('success', event, validator);
				}
			});
			
		};
		
		this.handleSelectVariant = function () {
			$body.on("select-variant-opendropDown-before", function (e, itm) {
				TweenMax.to($('.hideOnSelectVariant'), 0.8, {opacity: 0});
			});
			$body.on("select-variant-closedropDown-after", function (e, itm) {
				TweenMax.to($('.hideOnSelectVariant'), 0.8, {opacity: 1});
			});
		};
		
		
		this.handleAccordion = function () {
			/**
			 * Non necessaria perché gestita da _onDocumentReady.js
			$('.accordion','#product_details_accordion').each(function (index, item) {
				//window.accordionController.add($(item));
			});
			 */
			
			$body.on("select-variant-opendropDown-before", function (e, itm) {
				TweenMax.to($('.hideOnSelectVariant'), 0.8, {opacity: 0, height: 0});
			});
			$body.on("select-variant-closedropDown-after", function (e, itm) {
				TweenMax.to($('.hideOnSelectVariant'), 0.8, {opacity: 1, height: ''});
			});
		};
		
		this.initStickyMeta = function () {
			let HeaderH = $('.header-container').outerHeight() + 10 + 'px';
			
			
			// let MT =  'calc(50% - ' + HeaderH + 'px - ' + $('.product-single__meta_container').height() + 'px)';
			
			/*	if ($('#ProductSection--product-template').height() >  $(window).height() ) {
					
					let MT =  $(window).height()  - $('.product-single__meta_container').height();
				
				} else {
					let MT =  $('#ProductSection--product-template').height()  - $('.product-single__meta_container').height();
					
				}
				
				 $('.product-single__meta_container').css({'marginTop': HeaderH});
				*/
			
		};
		
		this.init = function (dom) {
			$self.initSizeTable();
			$self.initProductsModuleContacts();
			$self.initItemAdded();
			$self.initProductBar();
			$self.initStickyMeta();
			$self.initPopupContactsForm();
			$self.handleSelectVariant();
			$self.handleAccordion();
		};
	}
	
	// // Export variable
	let cc = new _cosProductTemplate();
	window.cosProductTemplate = {
		init: cc.init.bind(_cosProductTemplate),
		showItemAdded: cc.showItemAdded.bind(_cosProductTemplate),
		initProductBar: cc.initProductBar.bind(_cosProductTemplate),
		initStickyMeta: cc.initStickyMeta.bind(_cosProductTemplate)
	};
})();
/* Updated on: 30th Sep, 2:29:14 PM */